import React, { useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import {
  getDefaultServiceListAction,
  getDefaultTaskListAction,
  setUpdateDefaultServiceResponse,
  setUpdateDefaultTaskResponse,
  updateDefaultServiceAction,
  updateDefaultTaskAction,
} from "../../../../store/reducers/reviewSlice";
import ServiceTableSection from "./ServiceTableSection";
import TaskTableSection from "./TaskTableSection";

const TaskServiceTable = () => {
  const dispatch = useDispatch();
  const { defaultServiceList = [], defaultTaskList = [],isDefaultServiceResponse,isDefaultTaskResponse } = useSelector(
    (state: any) => state.review,
  );

  useEffect(() => {
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    dispatch(getDefaultServiceListAction());
    dispatch(getDefaultTaskListAction());
  }, [dispatch]);

  const [serviceData, setServiceData] = useState<any[]>([]);
  const [taskData, setTaskData] = useState<any[]>([]);
  const [editingServiceRowId, setEditingServiceRowId] = useState<number | null>(null);
  const [editingTaskRowId, setEditingTaskRowId] = useState<number | null>(null);
  const [activeTab, setActiveTab] = useState<"service" | "task">("service");
  const [serviceEditBackup, setServiceEditBackup] = useState<any | null>(null);
  const [taskEditBackup, setTaskEditBackup] = useState<any | null>(null);

  useEffect(() => {
    setServiceData(defaultServiceList);
  }, [defaultServiceList]);

  useEffect(()=>{
    if(isDefaultServiceResponse){
      dispatch(setUpdateDefaultServiceResponse(false));
      setEditingServiceRowId(null);
      setServiceEditBackup(null);
    }
  },[dispatch, isDefaultServiceResponse])

  useEffect(()=>{
    if(isDefaultTaskResponse){
      dispatch(setUpdateDefaultTaskResponse(false));
      setEditingTaskRowId(null);
      setTaskEditBackup(null);
    }
  },[dispatch, isDefaultTaskResponse])

  useEffect(() => {
    setTaskData(defaultTaskList);
  }, [defaultTaskList]);

  const [filterOption, setFilterOption] = useState({
    page: 1,
    limit: 10,
    orderBy: "created_at",
    orderIn: "DESC",
  });

  const createNewServiceRow = () => ({
    id: null,
    name: "",
    description: "",
    appears_in: "Survey/Quote/Confirmation",
  });

    const createNewTaskRow = () => ({
    id: null,
    name: "",
    description: "",
    appears_in: "Work Diary",
  })

  const handleTabChange = (
    event: React.SyntheticEvent,
    newValue: "service" | "task",
  ) => {
    setActiveTab(newValue);
  };

  const handleAddNewServiceRow = () => {
    const newRow = createNewServiceRow();
    setServiceData((prev: any[]) => [newRow, ...prev]);
    setEditingServiceRowId(newRow.id);
    setServiceEditBackup({ ...newRow });
  };

  const handleAddNewTaskRow = () => {
    const newRow = createNewTaskRow();
    setTaskData((prev: any[]) => [newRow, ...prev]);
    setEditingTaskRowId(newRow.id);
    setTaskEditBackup({ ...newRow });
  };

  const handleEditService = (id: number) => {
    const rowToEdit = serviceData.find((row: any) => row.id === id);
    setServiceEditBackup(rowToEdit ? { ...rowToEdit } : null);
    setEditingServiceRowId(id);
  };
  const handleSaveService = (id: number) => {
    const rowToSave = serviceData.find((row: any) => row.id === id);
    if (rowToSave) {
      dispatch(updateDefaultServiceAction(rowToSave));
    }
  };
  const handleCancelService = () => {
    if (editingServiceRowId !== null && serviceEditBackup) {
      setServiceData((prev) =>
        prev.map((row: any) =>
          row.id === editingServiceRowId ? { ...serviceEditBackup } : row,
        ),
      );
    }
    setEditingServiceRowId(null);
    setServiceEditBackup(null);
  };
  const handleChangeService = (id: number, field: string, value: string) => {
    setServiceData((prev) =>
      prev.map((row) => (row.id === id ? { ...row, [field]: value } : row)),
    );
  };
  const handleDeleteService = (id: number) => {
    setServiceData((prev) => prev.filter((row) => row.id !== id));
    if (editingServiceRowId === id) {
      setEditingServiceRowId(null);
      setServiceEditBackup(null);
    }
  };

  // Task handlers
  const handleEditTask = (id: number) => {
    const rowToEdit = taskData.find((row: any) => row.id === id);
    setTaskEditBackup(rowToEdit ? { ...rowToEdit } : null);
    setEditingTaskRowId(id);
  };
  const handleSaveTask = (row: any) => {
   
    dispatch(updateDefaultTaskAction(row));
    // if (editingTaskRowId === row.id) {
    //   setEditingTaskRowId(null);
    //   setTaskEditBackup(null);
    // }
  };
  const handleCancelTask = () => {
    if (editingTaskRowId !== null && taskEditBackup) {
      setTaskData((prev) =>
        prev.map((row: any) =>
          row.id === editingTaskRowId ? { ...taskEditBackup } : row,
        ),
      );
    }
    setEditingTaskRowId(null);
    setTaskEditBackup(null);
  };
  const handleChangeTask = (id: number, field: string, value: string) => {
    setTaskData((prev) =>
      prev.map((row) => (row.id === id ? { ...row, [field]: value } : row)),
    );
  };
  const handleDeleteTask = (id: number) => {
    setTaskData((prev) => prev.filter((row) => row.id !== id));
    if (editingTaskRowId === id) {
      setEditingTaskRowId(null);
      setTaskEditBackup(null);
    }
  };

  return (
    <>
      <Box
        sx={{
          bgcolor: "#fff",
          border: "1px solid #d1cfcf",
          borderRadius: "5px",
          mt: 2,
          px: 1,
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="service and task tabs"
        >
          <Tab value="service" label="Service List" />
          <Tab value="task" label="Task List" />
        </Tabs>
      </Box>

      {activeTab === "service" && (
        <ServiceTableSection
          data={serviceData}
          editingRowId={editingServiceRowId}
          filterOption={filterOption}
          setFilterOption={setFilterOption}
          onAddNew={handleAddNewServiceRow}
          onEdit={handleEditService}
          onSave={handleSaveService}
          onCancel={handleCancelService}
          onChange={handleChangeService}
          onDelete={handleDeleteService}
        />
      )}

      {activeTab === "task" && (
        <TaskTableSection
          data={taskData}
          editingRowId={editingTaskRowId}
          filterOption={filterOption}
          setFilterOption={setFilterOption}
          onAddNew={handleAddNewTaskRow}
          onEdit={handleEditTask}
          onSave={handleSaveTask}
          onCancel={handleCancelTask}
          onChange={handleChangeTask}
          onDelete={handleDeleteTask}
        />
      )}
    </>
  );
};

export default TaskServiceTable;
